import ØØReact, { memo } from "react";

import {
  AnalyzeTinybirdResourceResponseBodyType,
  CustomEventDto,
  GraphConfig,
} from "@intelligems/ig-types";
import Grid from "@mui/material/Grid";
import { MetricDetailSection } from "@src/features/analytics/metricDetails/MetricDetailSection";
import { OrdersReconciliationTable } from "@src/features/analytics/tables/OrdersReconciliationTable";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import { selectedVariations } from "@src/store/slices/variations";
import { UseQueryResult } from "@tanstack/react-query";

interface ConversionAnalyticsPageProps {
  data: UseQueryResult<AnalyzeTinybirdResourceResponseBodyType>[];
  totalExperienceVisitors: number;
  graphConfigs: GraphConfig[];
  testDuration: number;
  compareVariationId: string;
}

export const OrdersReconciliationAnalyticsPage = memo(
  ({
    data,
    totalExperienceVisitors,
    graphConfigs,
    testDuration,
    compareVariationId,
  }: ConversionAnalyticsPageProps) => {
    const experience = useSelector(selectedExperience);
    const variations = useSelector(selectedVariations);

    return (
      <Grid size={12}>
        <MetricDetailSection
          title={"Order Reconciliation Details"}
          metricDetails={{
            isPrimary: false,
          }}
        >
          <OrdersReconciliationTable data={data} />
        </MetricDetailSection>
      </Grid>
    );
  }
);
